module.exports = __webpack_public_path__ + "static/media/cacBuffet2.5b4ecc48.jpg";